import styled from "@emotion/styled";

export const SortDirectionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--mb-color-text-white);
  font-weight: 700;
  cursor: pointer;
`;
